import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import AuthCallback from "@/components/app/AuthCallback";
import AppLayout from "@/components/app/AppLayout";
import DashboardPage from "@/pages/DashboardPage";
import NewAnalysisPage from "@/pages/NewAnalysisPage";
import AnalysisResultsPage from "@/pages/AnalysisResultsPage";
import MyAnalysesPage from "@/pages/MyAnalysesPage";
import SharedAnalysisPage from "@/pages/SharedAnalysisPage";
import ComparePage from "@/pages/ComparePage";
import SettingsPage from "@/pages/SettingsPage";
import TeamAdminPage from "@/pages/TeamAdminPage";
import JoinTeamPage from "@/pages/JoinTeamPage";
import ReportsPage from "@/pages/ReportsPage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import CookieSettingsPage from "@/pages/CookieSettingsPage";
import ContactPage from "@/pages/ContactPage";
import CookieBanner from "@/components/CookieBanner";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#F8F9FC] flex items-center justify-center">
        <div className="w-8 h-8 border-3 border-orange-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  // Check URL fragment for session_id synchronously during render
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/shared/:shareId" element={<SharedAnalysisPage />} />
      <Route path="/dashboard" element={<ProtectedRoute><AppLayout><DashboardPage /></AppLayout></ProtectedRoute>} />
      <Route path="/analyze/new" element={<ProtectedRoute><AppLayout><NewAnalysisPage /></AppLayout></ProtectedRoute>} />
      <Route path="/analyze/:id" element={<ProtectedRoute><AppLayout><AnalysisResultsPage /></AppLayout></ProtectedRoute>} />
      <Route path="/analyses" element={<ProtectedRoute><AppLayout><MyAnalysesPage /></AppLayout></ProtectedRoute>} />
      <Route path="/compare" element={<ProtectedRoute><AppLayout><ComparePage /></AppLayout></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><AppLayout><SettingsPage /></AppLayout></ProtectedRoute>} />
      <Route path="/reports" element={<ProtectedRoute><AppLayout><ReportsPage /></AppLayout></ProtectedRoute>} />
      <Route path="/team" element={<ProtectedRoute><AppLayout><TeamAdminPage /></AppLayout></ProtectedRoute>} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/cookie-settings" element={<CookieSettingsPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/join/:token" element={<JoinTeamPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <CookieBanner />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
